import { useState } from 'react';
import { toast } from 'react-toastify';
import ModalContainer from '../../modalContainer';
import { updateSchoolActive } from '../../../API/apiService';
import HatSchoolBlue from '../../../assets/icons/hatSchoolBlue.svg';
import EditIcon from '../../../assets/icons/edit.svg';
import './style.scss';

function SchoolCardMini({
  school,
  onEditEvidence,
  onSchoolActivated,
  isMediatorCop = false,
  isSocialControlMediator = false
}) {
  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const [updatingActive, setUpdatingActive] = useState(false);

  function openVerification() {
    setOpenVerifyModal(true);
  }

  async function confirmActivation() {
    if (!school?.id || updatingActive) return;

    if (school?.active === true) {
      setOpenVerifyModal(false);
      toast(
        isMediatorCop
          ? 'La asesoria ya estaba verificada'
          : isSocialControlMediator
            ? 'La actividad ya estaba verificada'
            : 'El proceso formativo ya estaba verificado',
        { type: 'info' }
      );
      return;
    }

    setUpdatingActive(true);
    const updated = await updateSchoolActive(Number(school.id), true);
    setUpdatingActive(false);

    if (updated) {
      toast(
        isMediatorCop
          ? 'Asesoria verificada'
          : isSocialControlMediator
            ? 'Actividad verificada'
            : 'Proceso formativo verificado',
        { type: 'success' }
      );
      setOpenVerifyModal(false);
      onSchoolActivated?.(Number(school.id));
    }
  }

  return (
    <>
      {openVerifyModal && (
        <ModalContainer>
          <section className='mini-verify-modal'>
            <h3 className='mini-verify-modal__title'>
              {isMediatorCop
                ? 'Se abrira un proceso formativo en esta asesoria?'
                : isSocialControlMediator
                  ? '¿Confirmas la verificación de esta actividad?'
                  : 'Confirmas la verificacion de este proceso formativo?'}
            </h3>

            <div className='mini-verify-modal__actions'>
              <button
                type='button'
                className='blue-site-button'
                onClick={confirmActivation}
                disabled={updatingActive}
              >
                {updatingActive ? 'GUARDANDO...' : 'SI'}
              </button>

              <button
                type='button'
                className='button-white-border-blue'
                onClick={() => setOpenVerifyModal(false)}
                disabled={updatingActive}
              >
                NO
              </button>
            </div>
          </section>
        </ModalContainer>
      )}

      <div className='school-mini'>
        <div className='school-mini__info'>
          <div className='mini-row'>
            <div className='mini-icon'>
              <img
                src={HatSchoolBlue}
                className='mini-icon__img mini-icon__img--svg'
                alt=''
                aria-hidden='true'
              />
            </div>
            <div className='mini-text'>
              <span className='mini-label'>Comuna</span>
              <span className='mini-value'>{school?.municipality?.name ?? '-'}</span>
            </div>
          </div>

          <div className='mini-row'>
            <div className='mini-icon'>
              <img
                src={HatSchoolBlue}
                className='mini-icon__img mini-icon__img--svg'
                alt=''
                aria-hidden='true'
              />
            </div>
            <div className='mini-text'>
              <span className='mini-label'>
                {isMediatorCop
                  ? 'Nombre de Asesoria'
                  : isSocialControlMediator
                    ? 'Nombre de la Organización'
                    : 'Nombre de la Entidad Aliada'}
              </span>
              <span className='mini-value mini-value--strong'>
                {school?.name ?? school?.address ?? school?.code ?? '-'}
              </span>
            </div>
          </div>
        </div>

        <div className='mini-actions'>
          {school?.active !== true && (
            <button
              type='button'
              className='mini-btn mini-btn--verify'
              onClick={openVerification}
            >
              <span className='material-symbols-rounded mini-btn__icon' aria-hidden='true'>
                task_alt
              </span>
              <span className='mini-btn__text'>Verificacion</span>
            </button>
          )}

          <button
            type='button'
            className='mini-btn mini-btn--menu'
            onClick={() => onEditEvidence?.(school)}
          >
            <img
              src={EditIcon}
              className='mini-btn__icon mini-btn__icon--img'
              alt=''
              aria-hidden='true'
            />
            <span className='mini-btn__text'>Editar Concertación</span>
          </button>
        </div>
      </div>
    </>
  );
}

export default SchoolCardMini;

